export default function ($translate) {
    return {
        KEYS: {
            NOTIFICATION_NOT_SENT: 'NOTIFICATION_NOT_SENT',
            NOT_COMPLETED: 'NOT_COMPLETED',
            COMPLETED: 'COMPLETED'
        },
        LABELS: {
            NOTIFICATION_NOT_SENT: $translate.instant('evaluation.Notification not sent'),
            NOT_COMPLETED: $translate.instant('evaluation.Not completed'),
            COMPLETED: $translate.instant('evaluation.Completed')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/evaluation/status/index.js